module.exports = __webpack_public_path__ + "assets/img/22_1336.9ff7496d.jpg";